<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? '新增' : dataForm.clockInDTO.status === 4 ? '修改':'活动细则'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close='closeHandle'
  >
    <el-form
      :disabled="dataForm.clockInDTO.status === 4 ? false : dataForm.id ? true : false"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"
    >
      <el-form-item label="活动名称" prop="clockInDTO.name">
        <el-input v-model="dataForm.clockInDTO.name" placeholder="活动名称"></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="clockInDTO.startTime">
        <el-date-picker
          v-model="dataForm.clockInDTO.startTime"
          type="datetime"
          :disabled="timeLimited"
          value-format="timestamp"
          placeholder="年/月/日"
        ></el-date-picker>&nbsp;至&nbsp;
        <el-date-picker
          prop="clockInDTO.endTime"
          v-model="dataForm.clockInDTO.endTime"
          type="datetime"
          value-format="timestamp"
          placeholder="年/月/日"
          @change="changeEndTime(dataForm.clockInDTO.endTime)"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button v-if="dataForm.clockInDTO.status === 4 || !dataForm.id" @click="closeHandle()">取消</el-button>
      <el-button v-else @click="closeHandle()">关闭</el-button>
      <el-button v-if="dataForm.clockInDTO.status === 4 || !dataForm.id" type="primary" @click="dataFormSubmitHandle()">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import quill from "./import/table/quill.vue";
import Url from '@/views/crs/util/url';
export default {
  components: {
    quill
  },
  data() {
    return {
      index0: -100,
      index1: -100,
      visible: false,
      timeLimited: false,
      OldEndTime: "",
      addNum: 0,
      dataForm: {
        id: "",
        clockInDTO: {
          id: "",
          name: "",
          startTime: "",
          endTime: ""
        },
        isBy: ""
      }
    };
  },
  computed: {
    dataRule() {
      return {
        "clockInDTO.name": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "clockInDTO.startTime": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "clockInDTO.endTime": [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo("0");
        } else {
          this.$refs.quills.init("");
          this.$refs.quills1.init("");
          this.$refs.quills2.init("");
          this.dataForm.clockInDTO.endTime=null;
          this.dataForm.isBy=null;
          this.timeLimited = false;
        }
      });
    },
    initCopy() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.getInfo("1");
        this.dataForm.id = null;
        this.dataForm.clockInDTO.id = null;

      });
    },
    indexMethod(index) {
      return index;
    },
    changeEndTime(val) {
      if (this.dataForm.id) {
        if (val < this.OldEndTime) {
          this.dataForm.clockInDTO.endTime = this.OldEndTime;
          this.$message("结束时间只能往后延期，请谨慎操作");
        }
      } else {
        return;
      }
    },handleInput2(e) {
    // 通过正则过滤小数点后两位
    e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null

  },
    // 获取信息
    getInfo(copy) {
      this.$axios
        .get(`${Url.clockIn.event.id}${this.dataForm.id}`)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          };
          this.OldEndTime = res.data.clockInDTO.endTime;
          this.dataForm.clockInDTO.startTime = new Date(this.dataForm.clockInDTO.startTime).getTime();
          this.dataForm.clockInDTO.endTime = new Date(this.dataForm.clockInDTO.endTime).getTime();
          if (res.data.isBy == 1) {
            this.timeLimited = true;
          } else {
            this.timeLimited = false;
          }
          if(copy == "1" || copy == 1){
              //复制内容，时间不禁用
              this.timeLimited = false;
              this.dataForm.isBy=null;
              this.dataForm.clockInDTO.status=null;
          }
        })
        .catch(() => {});
    },
    closeHandle(){
      this.visible = false;
      location.reload();
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate(valid => {
          if (!valid) {
            return false;
          }
          this.$axios({
            headers:{"isAjax": 'true', 'Content-Type': 'application/json'},
            method:!this.dataForm.clockInDTO.id ? "post" : "put",
            url:Url.clockIn.event.save,
            data:this.dataForm
          }).then(res => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: "成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                  location.reload();
                }
              });
              this.visible = false;
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    )
  }
};
</script>
<style lang="scss" scoped>
.price_set {
  ul {
    li {
      ul {
        display: flex;
        li {
          width: 50px;
          input {
            width: 50px;
          }
        }
      }
    }
  }
}
ul,
li {
  list-style: none;
}
</style>
